import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { SnackbarProvider } from 'notistack';
import { Alert, Snackbar } from '@mui/material';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  /*<React.StrictMode>*/
  < SnackbarProvider maxSnack={3} autoHideDuration={2000}>
    <App />
  </SnackbarProvider >
  /*</React.StrictMode>*/
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
